import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  resolve: () => import('./dashboard')
});


// WEBPACK FOOTER //
// ./src/interface/layout/entry/Dashboard/component/index.js